import React, { Fragment } from 'react'
import styled, { keyframes } from 'styled-components'
import Button from '../CustomButtons/Button'
import Ticker from '../Ticker'

import EarthSVG from '-!svg-react-loader!../../assets/img/svg/Earth.svg'
import HeroGraphic from '-!svg-react-loader!../../assets/img/svg/HeroGraphic.svg'
import { primaryColor } from '../../assets/jss/material-kit-pro-react'

const Hero = ({ ticker }) => {
  return (
    <Fragment>
      <HeroContainer>
        <Earth />
        <HeroFlex>
          <HeroText>
            <h1>CANADA'S BEST</h1>
            <h2>Crypto Network</h2>
            <h5>
              Buy & Sell Cryptocurrency on Canada’s most advanced and
              comprehensive crypto exchange network
            </h5>
            <Button
              href="https://exchange.bitnational.com/?register=true"
              style={{ color: primaryColor }}
              round
              color="info"
            >
              Sign Up
            </Button>
          </HeroText>
          <div>
            <Graphic />
          </div>
        </HeroFlex>
        {typeof window !== 'undefined' && (
          <TickerContainer>
            <Ticker ticker={ticker} />
          </TickerContainer>
        )}
      </HeroContainer>
      <ButtonContainer>
        <Button
          size="lg"
          simple
          color="primary"
          href="https://exchange.bitnational.com/?login=true"
        >
          Go to Exchange →
        </Button>
      </ButtonContainer>
    </Fragment>
  )
}

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 5px;
`

const TickerContainer = styled.div`
  width: 100%;

  position: relative;
  a {
    float: right;
    margin-right: ${p => p.theme.col(0.5)};
  }
`

const Pulse = keyframes`
0% {
stroke-width: 0
opacity: 0;
}
10% {
 opacity: 1;
}
60% {
 stroke-width: 0
opacity: 1;
}
100% {
 stroke-width: 50
 opacity: 0;
}
`

const Graphic = styled(HeroGraphic)`
  z-index: 9;
  position: relative;
  max-width: 90vw;
  width: ${p => p.theme.col(11)};
  padding-right: ${p => p.theme.col()};
  padding-top: ${p => p.theme.col(3)};
  padding-bottom: ${p => p.theme.col(2)};

  .st276 {
    animation: ${Pulse} 10s ease-in-out infinite;
  }

  @media screen and (max-width: 1350px) {
    position: relative;
    margin-left: auto;
    display: block;
    width: 60%;
    max-width: initial;
    right: ${p => p.theme.col()};
    align-self: flex-end;
    top: 0;
    bottom: 0;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    right: 0;
  }
`

const HeroText = styled.div`
  padding: 0 ${p => p.theme.col(2)};
  margin-top: 200px;
  position: relative;
  z-index: 9;
  @media screen and (max-width: 1350px) {
    position: relative;
    margin-top: 100px;
  }
  h1 {
    font-weight: 900;
    font-size: 4em;
    color: ${p => p.theme.colors.cyan};
    margin: 0;
    line-height: 1;

    @media screen and (max-width: 768px) {
      font-size: 200%;
    }
  }
  h2 {
    color: white;
    line-height: 1.15;
    margin: 0;

    @media screen and (max-width: 768px) {
      font-size: 200%;
    }
  }
  h5 {
    margin-top: 3em;
    max-width: 450px;
    color: white;

    @media screen and (max-width: 768px) {
      margin-top: 1.5rem;
    }
  }
  button {
    margin-top: 2em;
    span {
      color: ${p => p.theme.colors.blue};
      font-weight: 600;
    }
  }
`

const Earth = styled(EarthSVG)`
  z-index: 1;
  position: absolute;
  max-width: 100vw;
  pointer-events: none;
`

const HeroContainer = styled.div`
  height: 100%;
  width: 100vw;
  overflow: hidden;
  background: #212343;
  background-image: linear-gradient(
    -160deg,
    ${p => p.theme.colors.blue},
    #212343
  );

  @media screen and (max-width: 1350px) {
    height: auto;
    display: block;
  }
`

const HeroFlex = styled.div`
  display: flex;
  width: 100%;

  @media screen and (max-width: 1350px) {
    flex-wrap: wrap;
  }
`

const HeroSlant = styled.div`
  width: 100%;
  height: 90%;
  overflow: hidden;
  background-image: linear-gradient(
    -160deg,
    ${p => p.theme.colors.blue},
    #212343
  );
`

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero/index.jsx